<section class="profile-skeleton" role="status" aria-label="Loading profile details" aria-busy="true">
  <ng-container *ngIf="variant === 'page'">
    <app-avatar-banner *ngIf="name; else emptyBanner" mode="full" [name]="name" [editable]="false"
      [appearance]="appearance" [resolvedDisplay]="resolvedDisplay" [avatarMediaId]="avatarMediaId" [bannerMediaId]="bannerMediaId"></app-avatar-banner>
    <ng-template #emptyBanner><div class="banner skeleton" aria-hidden="true"><div class="avatar skeleton"></div><div class="banner-name skeleton"></div></div></ng-template>
  </ng-container>
  <div class="profile-columns" [class.activity-only]="variant === 'activity'">
    <aside *ngIf="variant !== 'activity'" class="profile-sidebar">
      <ng-container *ngIf="name; else emptyName"><h2>{{ name }}</h2><p *ngIf="description">{{ description }}</p></ng-container>
      <ng-template #emptyName><div class="line heading skeleton" aria-hidden="true"></div></ng-template>
      <div class="placeholder-lines" aria-hidden="true"><div class="line skeleton"></div><div class="line short skeleton"></div>
        <div class="badges"><span *ngFor="let row of rows" class="medal skeleton"></span></div>
        <div class="sidebar-card skeleton"></div>
      </div>
    </aside>
    <div class="profile-detail" aria-hidden="true">
      <div *ngIf="variant !== 'activity'" class="tabs"><span *ngFor="let row of rows" class="tab skeleton"></span></div>
      <div class="totals"><span *ngFor="let row of rows" class="total skeleton"></span></div>
      <div class="activity-row" *ngFor="let row of rows"><span class="activity-icon skeleton"></span><div><div class="line skeleton"></div><div class="line short skeleton"></div></div></div>
    </div>
  </div>
</section>
